import { render, staticRenderFns } from "./AnnualReport.vue?vue&type=template&id=05f08a4b&scoped=true&"
import script from "./AnnualReport.vue?vue&type=script&lang=js&"
export * from "./AnnualReport.vue?vue&type=script&lang=js&"
import style0 from "./AnnualReport.vue?vue&type=style&index=0&id=05f08a4b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f08a4b",
  null
  
)

export default component.exports